import React from 'react';

const classNameByType = {
  big: 'text-5xl font-extrabold text-blue-10',
  medium: 'text-2xl font-bold text-blue-10',
  small: 'text-lg text-blue-10',
  xsmall: 'text-sm text-blue-10',
};

/**
 *
 * @param {{
 *   type: 'big' | 'medium' | 'small' | 'xsmall',
 *   text?: string,
 *   className?: string,
 *   children: React.ReactNode
 * }} props
 * @returns {JSX.Element}
 */

const Text = ({ type, text, className, children }) => {
  if (text || children)
    return (
      <p className={`${classNameByType[type] || ''} ${className}`}>
        {text && <span dangerouslySetInnerHTML={{ __html: text }} />}
        {children}
      </p>
    );

  return null;
};

export default Text;
